

const Footer = () => {
	const logoUrls = "/images/logo.balsolutions.svg";

	return (
		<footer>

			<div className="container">

				<div className="info">

					<img src={logoUrls} alt="BALSOLUTIONS" />

					<p className="mb-0">
						Servicios eléctricos industriales.
						<br />
						<span className="text-primary">Empresa familiar, tercera generación, desde 1965</span>
					</p>

				</div>

			</div>

		</footer>

	)
}

export default Footer;